import config from '@/config';
import { authorizationHeaders } from '@/stores/useAuthStore';

/**
 * POST multipart à l'API : un fichier arrive avec l'objet qu'il accompagne (ex. l'image d'une signature, POST
 * /time_sheet_signatures), comme sur la plateforme Stonecode. model-core n'envoie que du JSON (Content-Type imposé) :
 * même authentification (authorizationHeaders) et même erreur levée que lui (le « detail » d'API Platform, lu par
 * getApiErrorMessage), sans afficher l'erreur (le dialogue qui appelle la montre).
 *
 * @param path chemin de la ressource, sans la base de l'API (ex. '/time_sheet_signatures')
 * @param fields champs du formulaire : relations par URN, fichiers en Blob
 */
export async function postMultipart(
  path: string,
  fields: Record<string, string | Blob>,
): Promise<Record<string, unknown>> {
  const body = new FormData();
  for (const [name, value] of Object.entries(fields)) {
    body.append(name, value);
  }

  // Pas de Content-Type : le navigateur le pose avec la frontière du multipart
  const response = await fetch(`${config.apiUrl}${path}`, {
    method: 'POST',
    body,
    headers: { Accept: 'application/ld+json', ...(await authorizationHeaders()) },
  });
  const json = (await response.json().catch(() => null)) as Record<string, unknown> | null;

  if (!response.ok) {
    throw (json && (json.detail ?? json['hydra:description'] ?? json.message)) ?? response.statusText;
  }

  return json ?? {};
}
